import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Card from 'components/Card';
import CardHeader from 'components/CardHeader';
import Button from 'components/Button';
import ActiveMapLegend from 'assets/icons/activeMapLegend.svg'
import MapLegend from 'assets/icons/mapLegend.svg';
import FloorPlan from '../FloorPlan';
import Legend from '../Legend'
import StyledBadge from 'components/Badge';
import useWindowDimensions from 'customHook/useWindowDimensions';
import {
  FloorNumbers,
  ViewLegend,
} from './styles';
import colors from 'constants/colors';

const FloorCard = ({
  eighthFloorRooms,
  ninthFloorRooms,
  tenthFloorRooms,
}) => {
  
  const navigate = useNavigate();
  const location= useLocation();
  const floorNumber= Number(location.pathname.split('/')[2]);
  const [isLegendVisible, setIsLegendVisible] = useState(false);
  const { width } = useWindowDimensions()

  return (
    <Card
      additionalstyle={`
        width: 100%;
        @media only screen and (max-width: 1200px) {
          background-color: ${colors.black1};
          padding: 0;
        }
      `}
    >
      <CardHeader
        additionalstyle={`
          margin-bottom: 10px;
        `}
      >
        <div className="type">
          <FloorNumbers>
            <div>FLOOR</div>
            {[8, 9, 10].map((num) => (
              <StyledBadge
                key={num}
                className="floor"
                mobile="true"
                color="error"
                badgeContent=" "
                variant="dot"
                invisible={false}
              >
                <div
                  className={`number${floorNumber === num ? ' active' : ''}`}
                  onClick={() => navigate(`/floor/${num}`)}
                >
                  {num}
                </div>
              </StyledBadge>
            ))}
          </FloorNumbers>
          <ViewLegend
            onClick={() => setIsLegendVisible(!isLegendVisible)}
            active={isLegendVisible}
          >
            {
              isLegendVisible?
                <img src={ActiveMapLegend} alt={'activeMapLegend'}/>:
                <img src={MapLegend} alt={'mapLegend'}/>
            }
            <div>{isLegendVisible? 'HIDE LEGEND': 'VIEW LEGEND'}</div>
          </ViewLegend>
        </div>
        <Button
          mainPage
          desktop
          onClick={(event) => {
            if (event.metaKey || event.ctrlKey) {
              // Open new tab with absolute URL
              window.open(`https://pms.rookhotel.com/rooms`, '_blank', 'noopener,noreferrer')
            } else {
              // Normal navigation
              navigate('/rooms')
            }
          }}
          additionalstyle={`
            width: 142px;
          `}
        >
          Manage Rooms
        </Button>
      </CardHeader>
      {isLegendVisible? <Legend desktop/> : null}
      <FloorPlan selectedFloor={floorNumber} desktop backgroundColor={width>1200? colors.black2:colors.black1} eighthFloorRooms={eighthFloorRooms} ninthFloorRooms={ninthFloorRooms} tenthFloorRooms={tenthFloorRooms} />
      {isLegendVisible? <Legend mobile/> : null}
    </Card>
  )
}

export default FloorCard;
